const accounts = {
    title: "Account selectie van {professional}",
    tab: "Account selectie"
}

export default accounts;